'use client'

import { ButtonGhost } from '@fukku/button/Ghost/ButtonGhost'
import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { IconChatChatS } from 'icons/components/IconChatChatS'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { ChatbotFeatureFlag } from 'oldchatbot/types/ChatbotFeatureFlag'
import { openChatbot } from 'oldchatbot/utils/openChatbot/openChatbot'

import { dataTestIds } from '../../constants/dataTestIds/dataTestIds'
import { usePdpFeatureFlags } from '../../utils/getFeatureFlags/client/usePdpFeatureFlags'

import styles from './ChatbotLink.module.css'

export const ChatbotLink = () => {
	const { t } = useLabels()
	const { enabled: isChatbotEnabled } = useFeatureFlag<ChatbotFeatureFlag>(
		featureFlagKeys.Chatbot
	)
	const { chatbotLink: chatbotPdpFeatureFlag } = usePdpFeatureFlags()

	if (!isChatbotEnabled || !chatbotPdpFeatureFlag) {
		return null
	}

	return (
		<ButtonGhost
			onClick={openChatbot}
			className={styles.button}
			data-testid={dataTestIds['pdp.chatbot.button']}
		>
			<IconChatChatS color='content-success' />
			{t('chat.general.banner.title')}
		</ButtonGhost>
	)
}
